const DYNAMIC_CAMPAIGN_CHANNEL = (id: number) => `dynamic-campaign.${id}`;
const DYNAMIC_CAMPAIGN_STATUS_EVENT = ".App\\Events\\DynamicCampaign\\Action\\StatusChangedEvent";

export { DYNAMIC_CAMPAIGN_CHANNEL, DYNAMIC_CAMPAIGN_STATUS_EVENT };
